import {Component, Inject, OnInit, TemplateRef} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PositionAliasTo } from 'src/app/shared/models/positionAliasTo';
import { PositionAliasService } from '../position-alias.service';
import {SharedService} from '../../shared/shared.service';
import {Alerts} from '../../shared/enums/alerts';
import { PositionAliasBase } from '../position-alias-base';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { OrganizationTo } from 'src/app/shared/models/organizationTo';


@Component({
    selector: 'app-add-position-alias',
    templateUrl: './add-position-alias.component.html',
    styleUrl: './add-position-alias.component.scss'
})
export class AddPositionAliasComponent extends PositionAliasBase implements OnInit {

    organization: OrganizationTo;
    positionAlias: PositionAliasTo = new PositionAliasTo();
    header = "Add Position Alias";
    title: string;
  
    constructor(@Inject(MAT_DIALOG_DATA) public data : OrganizationTo,
                public dialogRef: MatDialogRef<AddPositionAliasComponent>,
                public sharedService: SharedService,
                public positionAliasService: PositionAliasService) {
        super();
    }

    ngOnInit() {
        this.organization = this.data;
        this.title = this.organization?.name;
    }

    addPositionAlias() {
        this.markFormControlsAsTouched();
        if (this.positionId.valid && this.alias.valid) {
            this.positionAlias.org = this.organization;
            this.loading = true;
            this.positionAliasService.createPositionAlias(this.positionAlias).subscribe({
                next: data => {
                    this.loading = false;
                    this.sharedService.showAlert(Alerts.SUCCESS, 'Position Alias added successfully');
                    this.dialogRef.close(true);
                },
                error: error => {
                    this.loading = false;
                    this.sharedService.handleErrors(error,
                        [{
                            "condition": (error.status === 400 && error.error?.length > 0),
                            "msg": error.error
                        }],
                        "Unable to add position alias");
                },
                complete: () => { }
            });
        } 
    }

    resetPositionAlias() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will be lost!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Reset',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.positionAlias = new PositionAliasTo();
                }
            });
        } else {
            this.positionAlias = new PositionAliasTo();
        }
    }

    close() {
        if (this.fieldcheck) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Your changes will not be saved !',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Close',
                cancelButtonText: 'No, Cancel',
            }).then((result) => {
                if (result.value) {
                    this.dialogRef.close(false);
                }
            });
        } else {
            this.dialogRef.close(false);
        }
    }
}
